import React from 'react'

import BaseComponent from 'utils/BaseComponent'

import Notification from './Notification'

import './styles.scss'

export default class NotificationList extends BaseComponent {
  constructor() {
    super()

    this._bind('_renderNotification')
  }

  _renderNotification(notification, index) {
    return (
      <Notification claimId={this.props.claimId} key={`${index}-${notification.id}`} notification={notification}/>
    )
  }

  render() {
    return (
      <div className="NotificationList">
        <ul>
          {this.props.notifications.map(this._renderNotification)}
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Claim/Notifications/NotificationList/index.js